import {getLocalizationBasedOnLang} from '../../data/models/User/UserInfo';

const english = {
  logOut: 'Log out',
  accountSettings: 'Profile settings',
};

const welsh = {logOut: 'Allgofnodi', accountSettings: 'Gosodiadau proffil'};

export const userMenuPopupText = getLocalizationBasedOnLang(english, welsh);
